import { render } from "./ShopWrapper.vue?vue&type=template&id=4bc976cc"
import script from "./ShopWrapper.vue?vue&type=script&lang=js"
export * from "./ShopWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__